import React from 'react'
import { useTranslation } from 'react-i18next'
import { Flame, HelpCircle, Zap } from 'lucide-react'
import useAudioManager from '../../../hooks/useAudioManager'
import { hapticImpact } from '../../../utils/haptic'

/**
 * Шапка эвента Rush Drop: картинка 16:9 (с фолбэком), название, бейджи, кнопка правил.
 */
const RushDropHeader = ({ event, state, placeShift, onOpenRules }) => {
  const { t } = useTranslation()
  const { playSound } = useAudioManager({ select: 'select' })

  const hasImage = Boolean(event?.image)

  return (
    <div className="relative overflow-hidden rounded-2xl border border-white/10 bg-surface">
      <div className="relative aspect-[16/9]">
        {hasImage ? (
          <img
            src={event.image}
            alt={event?.title || 'Rush Drop'}
            className="h-full w-full object-cover"
            loading="lazy"
          />
        ) : (
          // Фолбэк: пул картинок эвентов может быть пуст — пустой <img> не рисуем
          <div className="flex h-full w-full items-center justify-center bg-gradient-to-br from-accent-primary/25 via-surface to-accent-secondary/20">
            <Zap size={56} className="text-accent-primary/70" />
          </div>
        )}
        <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/25 to-black/10" />

        {/* Кнопка правил */}
        <button
          type="button"
          onClick={() => {
            playSound('select')
            hapticImpact('light')
            onOpenRules?.()
          }}
          className="absolute right-3 top-3 flex h-9 w-9 items-center justify-center rounded-full border border-white/15 bg-black/50 text-white backdrop-blur-md transition-all active:scale-95"
          aria-label={t('rushdrop.rules', 'Правила')}
        >
          <HelpCircle size={18} />
        </button>

        {/* Название + бейджи */}
        <div className="absolute bottom-3 left-4 right-4">
          <div className="mb-1.5 flex flex-wrap items-center gap-1.5">
            <span className="rounded-md bg-accent-primary px-2 py-0.5 text-[11px] font-bold uppercase tracking-wide text-dark-primary">
              Rush Drop
            </span>
            {state === 'ending' && (
              <span className="flex items-center gap-1 rounded-md bg-red-500/90 px-2 py-0.5 text-[11px] font-bold text-white">
                <Flame size={12} />
                {t('rushdrop.endingSoon', 'Финал скоро')}
              </span>
            )}
            {Number(placeShift) > 0 && (
              <span className="rounded-md border border-accent-secondary/40 bg-black/50 px-2 py-0.5 text-[11px] font-semibold text-accent-secondary">
                {t('rushdrop.placeShift', 'Необычный розыгрыш')}
              </span>
            )}
          </div>
          <h1 className="text-2xl font-black not-italic leading-tight text-white lg:text-3xl">
            {event?.title || 'Rush Drop'}
          </h1>
        </div>
      </div>
    </div>
  )
}

export default RushDropHeader
